import * as Sentry from '@sentry/react'
import { env } from '@/env'

export function initSentry() {
  if (!env.VITE_SENTRY_DSN) return
  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
  })
}
